import React from 'react';
import './Checkbox.scss';
import { Icon } from 'antd';

interface IProps {
  value?: boolean;
  style?: string;
  onChange?: (isChecked: boolean) => void;
}

interface IState {
  isChecked: boolean;
}

class Checkbox extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    const { value } = this.props;
    const isChecked = value === undefined ? false : value;

    this.state = {
      isChecked,
    }
  }

  componentWillReceiveProps(nextProps: IProps) {
    if (nextProps.value !== undefined) {
      this.setState({ isChecked: nextProps.value });
    }
  }

  toggleCheck = () => {
    this.setState({ isChecked: !this.state.isChecked },
      () => this.props.onChange(this.state.isChecked));
  }

  render() {
    const { isChecked } = this.state;
    const { style, children } = this.props;

    return (
      <div className={ `checkbox ${ style ? style : '' }` } >
        <div className={ isChecked ? 'box checked' : 'box' } onClick={ this.toggleCheck }>
          { isChecked && <Icon type='check' /> }
        </div>
        <div>{ children }</div>
      </div>
    );
  }
}

export default Checkbox;


// WEBPACK FOOTER //
// ./src/components/Shared/Checkbox/Checkbox.tsx